import React, { useEffect, useRef, useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import _ from "lodash";
import base64url from "base64-url";
import qs from "qs";

import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { auth } from "../../firebase.js";
import AuthLayout from "../../components/AuthLayout.js";
import Message from "../../components/Message.js";
import Button from "../../components/Button.js";

const errorMessages = {
  default: "Inloggen is niet gelukt. Probeer het opnieuw of neem contact op met support.",
  "auth/invalid-action-code": "Helaas, deze link is verlopen of al gebruikt. Vraag een nieuwe login-link aan.",
};

function SignIn() {
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  let qemail = "";
  if (query.email) {
    qemail = base64url.decode(query.email);
  }

  const [email, setEmail] = useState(qemail || "");
  const [info, setInfo] = useState("");
  const [error, setError] = useState("");
  const autoSignInAttempted = useRef(false);

  useEffect(() => {
    if (autoSignInAttempted.current || !qemail) return;
    if (!isSignInWithEmailLink(auth, window.location.href)) return;
    autoSignInAttempted.current = true;

    setInfo("Een moment, u wordt ingelogd...");
    signInWithEmailLink(auth, qemail, window.location.href).catch((err) => {
      console.error(err);
      setInfo("");
      setError(errorMessages[err.code] || errorMessages["default"]);
    });
  }, [qemail]);

  async function onSubmit(event) {
    event.preventDefault();
    setError("");
    setInfo("");

    try {
      await signInWithEmailLink(auth, email, window.location.href);
      setInfo("U bent succesvol ingelogd!");
    } catch (err) {
      console.error(err);
      setError(errorMessages[err.code] || errorMessages["default"]);
    }
  }

  if (auth.currentUser && !auth.currentUser.isAnonymous) {
    return <Navigate replace to={_.get(location.state, "from", "/")} />;
  }

  return (
    <AuthLayout>
      <form id="sign-in" onSubmit={onSubmit}>
        <h2 className="text-2xl font-heading font-bold mb-2">Login via email link</h2>
        <p className="text-sm text-text-secondary mb-6">Login om uw locaties te bekijken en te wijzigen</p>

        {!!error && (
          <div className="mb-4">
            <Message text={error} />
          </div>
        )}
        {!!info && (
          <div className="mb-4">
            <Message variant="info" text={info} />
          </div>
        )}

        <div className="space-y-4 mb-6">
          <div>
            <label className="label-base">Email</label>
            <input
              name="email"
              type="email"
              placeholder="Je emailadres"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-base"
            />
          </div>
        </div>

        <div className="flex gap-3">
          <Button type="submit" label="Login" className="flex-1" />
          <Link
            to="/login"
            className="inline-flex items-center justify-center min-h-button px-4 py-2 text-base font-medium rounded-sm border border-border text-text-secondary hover:bg-bg-sunken transition-colors duration-fast"
          >
            Annuleren
          </Link>
        </div>
      </form>
    </AuthLayout>
  );
}

export default SignIn;
